import(/* webpackMode: "eager" */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/app/(public)/support/page.tsx");
